<template>
  <v-slider
    v-model="form"
    dense
    height="20px"
    hide-details
    max="100"
    min="0"
    small
    step="1"
    thumb-label
  ></v-slider>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 1,
    },
  },
  data: () => ({}),
  computed: {
    form: {
      get() {
        return this.value * 100
      },
      set(value) {
        this.$emit('input', +value / 100)
      },
    },
  },
  methods: {},
}
</script>

<style scoped></style>
